/**
 * * Отображаемые элементы в задаче
 */
export enum TaskViewElementEnum {
  Author = "author",
  Performers = "performers",
  Observers = "observers",
  Status = "status",
  Priority = "priority",
  Tags = "tags",
  Type = "type",
  DateCreate = "date-create",
  Queue = "queue",
  Difficulty = "difficulty",
  AttachedFiles = "attached-files",
  Deadline = "deadline",
  Number = "number",
  Name = "name",
  EstimateTime = "estimateTime",
  WorkTime = "workTime",
  Namespace = "namespace",
  Project = "project"
}
